import Quill from 'quill'
const Image = Quill.import('formats/image')

class ImageBlot extends Image {
  static create(value) {
    let node = super.create()
    node.setAttribute('src', value.src)
    node.setAttribute('alt', value.alt || '')
    return node
  }

  static value(node) {
    return {
      src: node.getAttribute('src'),
      alt: node.getAttribute('alt'),
    }
  }
}

Quill.register(ImageBlot, true)
